module.exports = __webpack_public_path__ + "static/img/menageService6.bdd47fad.png";